import styled from 'styled-components';

import Tag from 'components/v2/Tag';

export const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${({ $palette }) => $palette.text};
    background: ${({ $palette }) => $palette.background};
    border-color: ${({ $palette }) => $palette.border};
    border-radius: ${({ theme }) => theme.borderRadius.full};

    &&& .MuiChip-icon path {
      fill: ${({ $palette }) => $palette.border};
    }
  }
`;
